import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'lengthOfStay' })
export class LengthOfStayPipe implements PipeTransform {
  transform(value: { arrivalDate: DateTime; departureDate: DateTime }): number {
    return value.departureDate.diff(value.arrivalDate, 'days').days;
  }
}
